module.exports = __webpack_public_path__ + "static/img/cover5.a952c3fb.jpg";